import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { anchor: String };

  scroll(event) {
    event.preventDefault();
    const element = document.getElementById(this.anchorValue);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
}
